import { PipeTransform } from '@angular/core';
var CabinetTypePipe = /** @class */ (function () {
    function CabinetTypePipe() {
    }
    CabinetTypePipe.prototype.transform = function (value) {
        if (!value) {
            return '';
        }
        switch (value) {
            case 'DEPSUPER':
                return 'Deputy Superintendent';
            case 'CABINET':
                return 'Cabinet Member';
            case 'SUPER':
                return 'Superintendent';
            default:
                return value;
        }
    };
    return CabinetTypePipe;
}());
export { CabinetTypePipe };
